module.exports = __webpack_public_path__ + "static/media/damaged.b7a49695.svg";